import Route from 'cio/routes/base';

export default class CampaignUnfollowRoute extends Route {
  model() {
    return this.modelFor('campaigns.campaign');
  }

  redirect(model) {
    if (model.isDraft) {
      return this.router.transitionTo(
        `${model.isApiTriggered ? 'broadcasts.broadcast' : 'campaigns.campaign'}.setup`,
        model,
      );
    }

    return this.router.transitionTo('campaigns.campaign.overview', model, { queryParams: { unfollow: true } });
  }
}
